import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_info",
  "use": "svg_info-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"svg_info\"><g fill=\"none\" fill-rule=\"evenodd\" opacity=\".5\"><circle stroke=\"#000\" cx=\"8\" cy=\"8\" r=\"6.667\" /><path fill=\"#000\" d=\"M7.327 6.653h1.347v5.333H7.327zM7.32 4h1.333v1.333H7.32z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol